import React, { Component } from 'react';
import { Route, Switch } from 'react-router-dom';
import { connect } from 'react-redux';
import PrivateRoute from './PrivateRoute';
import Login from './auth/Login';
import ResetPassword from './auth/ResetPassword';
import ForgottenPassword from './auth/ForgottenPassword';
import Dashboard from './dashboard';
import BlockUi from 'react-block-ui';
import 'react-block-ui/style.css';
import { withAnalytics } from './common/services/analyticsTracker';

class LayoutRoot extends Component {

	render() {
		const { match, initializing } = this.props;

		return <BlockUi blocking={initializing} renderChildren={false}>
			<Switch>
				<Route path='/login' component={Login} />
				<Route path='/resetPassword' component={ResetPassword} />
				<Route path='/forgottenPassword' component={ForgottenPassword} />
				<PrivateRoute path='/' component={Dashboard} params={match.params} />
			</Switch>
		</BlockUi>;
	}
}

const mapStateToProps = state => ({
	initializing: state.auth.initializing
});

export default connect(mapStateToProps, {
})(withAnalytics(LayoutRoot));